export interface Category {
  id: string;
  name: string;
  namePt: string;
  url: string;
  icon: string;
  imageSeq: string;
  imageQuery: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    namePt: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'cat-shoes-01',
    imageQuery: 'Stylish%20fashion%20sneakers%20on%20clean%20minimal%20white%20background%2C%20modern%20lifestyle%20product%20photography%20with%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20warm%20neutral%20tones%2C%20editorial%20aesthetic',
    description: 'Sneakers exclusivos com os melhores preços',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    namePt: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-hoodies-01',
    imageQuery: 'Premium%20hoodie%20and%20sweater%20flat%20lay%20on%20light%20cream%20background%2C%20minimalist%20fashion%20photography%20with%20soft%20shadows%2C%20warm%20ambient%20light%2C%20clean%20aesthetic%20composition',
    description: 'Hoodies e sweaters de alta qualidade',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    namePt: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-tshirts-01',
    imageQuery: 'Premium%20cotton%20t-shirts%20neatly%20folded%20on%20minimal%20beige%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%20style%2C%20warm%20neutral%20aesthetic%2C%20editorial%20fashion%20shot',
    description: 'T-shirts com designs exclusivos',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    namePt: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-jackets-01',
    imageQuery: 'Stylish%20winter%20jacket%20on%20minimal%20light%20gray%20background%2C%20modern%20fashion%20product%20photography%20with%20soft%20diffused%20lighting%2C%20elegant%20composition%2C%20warm%20neutral%20tones',
    description: 'Jaquetas modernas para todas as estações',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    namePt: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    imageSeq: 'cat-pants-01',
    imageQuery: 'Casual%20pants%20and%20shorts%20flat%20lay%20on%20light%20cream%20surface%2C%20minimalist%20fashion%20photography%20with%20soft%20natural%20light%2C%20clean%20editorial%20aesthetic%2C%20warm%20neutral%20composition',
    description: 'Calças e shorts para todos os estilos',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    namePt: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-base-station-line',
    imageSeq: 'cat-headwear-01',
    imageQuery: 'Trendy%20caps%20and%20beanies%20on%20minimal%20white%20background%2C%20clean%20fashion%20product%20photography%20with%20soft%20shadows%2C%20modern%20lifestyle%20aesthetic%2C%20warm%20neutral%20lighting',
    description: 'Bonés e acessórios de cabeça',
  },
  {
    id: 'sets',
    name: 'Sets',
    namePt: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageSeq: 'cat-sets-01',
    imageQuery: 'Matching%20fashion%20outfit%20set%20on%20light%20beige%20background%2C%20coordinated%20clothing%20flat%20lay%2C%20minimalist%20product%20photography%20with%20soft%20natural%20light%2C%20elegant%20composition',
    description: 'Conjuntos coordenados exclusivos',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    namePt: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    imageSeq: 'cat-underwear-01',
    imageQuery: 'Premium%20cotton%20underwear%20neatly%20arranged%20on%20minimal%20cream%20background%2C%20clean%20product%20photography%20with%20soft%20diffused%20lighting%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style',
    description: 'Roupas íntimas de qualidade premium',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    namePt: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-jersey-01',
    imageQuery: 'Sports%20jersey%20on%20minimal%20light%20gray%20background%2C%20athletic%20wear%20product%20photography%20with%20soft%20studio%20lighting%2C%20clean%20modern%20aesthetic%2C%20warm%20neutral%20composition',
    description: 'Jerseys esportivas autênticas',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    namePt: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    imageSeq: 'cat-accessories-01',
    imageQuery: 'Fashion%20accessories%20collection%20on%20light%20beige%20surface%2C%20sunglasses%20and%20jewelry%20flat%20lay%2C%20minimalist%20product%20photography%20with%20soft%20natural%20light%2C%20elegant%20composition',
    description: 'Acessórios de moda tendência',
  },
  {
    id: 'bags',
    name: 'Bags',
    namePt: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    imageSeq: 'cat-bags-01',
    imageQuery: 'Designer%20style%20bag%20on%20minimal%20cream%20background%2C%20luxury%20fashion%20product%20photography%20with%20soft%20studio%20lighting%2C%20elegant%20composition%2C%20warm%20neutral%20aesthetic',
    description: 'Bolsas e mochilas premium',
  },
  {
    id: 'belts',
    name: 'Belts',
    namePt: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageSeq: 'cat-belts-01',
    imageQuery: 'Premium%20leather%20belt%20on%20minimal%20light%20gray%20background%2C%20clean%20product%20photography%20with%20soft%20natural%20lighting%2C%20elegant%20fashion%20aesthetic%2C%20warm%20neutral%20tones',
    description: 'Cintos de couro e moda',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    namePt: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageSeq: 'cat-perfumes-01',
    imageQuery: 'Elegant%20perfume%20bottle%20on%20minimal%20beige%20background%2C%20luxury%20fragrance%20product%20photography%20with%20soft%20studio%20lighting%2C%20refined%20composition%2C%20warm%20neutral%20aesthetic',
    description: 'Perfumes e fragrâncias exclusivas',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    namePt: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageSeq: 'cat-other-01',
    imageQuery: 'Various%20fashion%20items%20collection%20on%20light%20cream%20background%2C%20lifestyle%20product%20flat%20lay%20photography%20with%20soft%20natural%20light%2C%20warm%20neutral%20composition%2C%20editorial%20aesthetic',
    description: 'Outros itens e achados especiais',
  },
];